/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { Button } from 'reactstrap';
import SimpleTooltip from '../../../simple-tooltip';
import { ToolbarButtonProps } from './ToolbarButton';

const ToolbarStatusButton = (props: ToolbarButtonProps & { active: boolean }) => {
  const { contents, tooltip, btnClass, onClick, onMouseOver, disabled, active } = props;

  return (
    <div>
      <SimpleTooltip text={tooltip}>
        <Button
          color='transparent'
          disabled={disabled}
          className={`toolbar-status-button ${active ? 'active' : ''} ${btnClass ?? ''}`}
          onMouseOver={onMouseOver ? onMouseOver : () => { }}
          onClick={onClick ? onClick : () => { }}
        >
          {contents}
        </Button>
      </SimpleTooltip>
    </div>
  );
}

export default ToolbarStatusButton;
